// extracted by mini-css-extract-plugin
export var btn_class = "style-module--btn_class--6710b";
export var developer_card = "style-module--developer_card--90ee0";
export var developer_card_title = "style-module--developer_card_title--932c4";
export var tech_card = "style-module--tech_card--ac462";
export var tech_card_content = "style-module--tech_card_content--e53e3";